import { EventEmitter } from '@pixi/utils';
import type { Filter as PixiFilter } from 'pixi.js';
import { TypedParentMixin } from '../parentMixin';
import { TypedSerializableMixin } from '../serializableMixin';
import { TypedUpdateFlowMixin } from '../updateFlowMixin';

export abstract class Filter extends TypedUpdateFlowMixin(
    TypedParentMixin(TypedSerializableMixin(EventEmitter)),
) {
    abstract override _classType: string;
    /** @internal */
    abstract pixiFilter: PixiFilter;

    override get readonlyProperties() {
        return ['classType', 'name'];
    }

    get resolution(): number {
        return this.pixiFilter.resolution;
    }

    set resolution(value: number) {
        this.pixiFilter.resolution = value;
    }

    destroy() {
        this.pixiFilter.destroy();
    }
}
